import React from 'react';
import ProductBagIconButton from "./ProductBagIconButton";
import {useSelector} from "react-redux";

const CompareButton = () => {
    const {products, url} = useSelector((state) => state.comparisonProducts);

    return (
        <ProductBagIconButton quantity={products.length} text="Compare" icon='compare' href={url} active={products.length > 0}/>
    );
}

export default CompareButton;
